import { render } from "./page-footer.vue?vue&type=template&id=ce1a63f2&scoped=true"
const script = {}

import "./page-footer.vue?vue&type=style&index=0&id=ce1a63f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce1a63f2"]])

export default __exports__